import useMediaQuery from "@mui/material/useMediaQuery";
import { t } from "i18next";
import { Button } from "primereact/button";
import React from "react";
import { useNavigate } from "react-router-dom";
import PageLayoutWithSidebar from "../../../../../components/PageLayoutWithSidebar";
import config from "../../../../../config";
import QuickServicesWrapper from "./style";

const ServiceDescription = (props) => {
  const matches = useMediaQuery(
    `(min-width:${config.breakdowns.MOBILE_MAX_WIDTH}px)`
  );
  const navigate = useNavigate();

  return (
    <>
      <QuickServicesWrapper>
        <div className="d-flex justify-content-center mx-4">
          <p className="my-0 mx-2 fm-kufi-bold text-sm my-3">
            {t("quickServices.propertyDisclosureTitle")}
          </p>
        </div>

        <PageLayoutWithSidebar className="mt-4">
          <p className="fm-kufi-bold text-sm">
            {t("quickServices.serviceDescription")}
          </p>
          <p className="fm-kufi-regular text-sm">
            {t("quickServices.propertyDisclosureServiceDescription")}
          </p>
        </PageLayoutWithSidebar>

        <div className={`row justify-content-end my-4 ${matches ? "mx-2" : " mx-1"}`}>
          <Button
            onClick={() => navigate("/government-services/dls")}
            className="ant-btn action-btn col-md-2 back-btn  mt-5 justify-content-center text-center fm-kufi-regular text-sm"
          >
            {t("common.back")}
          </Button>
        </div>
      </QuickServicesWrapper>
    </>
  );
};

export default ServiceDescription;
